"use strict";
import React from "react";
import { Toggle } from "../Toggle/Toggle";
import { Card } from "../Card";
import { Stack } from "../Stack/Stack";
import * as styles from "./ToggleGroup-css";
export const ToggleGroup = ({
  name,
  on,
  items,
  disabled,
  onGroupToggle,
  onItemToggle,
  className
}) => /* @__PURE__ */ React.createElement(Card, { className }, /* @__PURE__ */ React.createElement(Stack, { className: styles.header, padding: "s", paddingLeft: "m", paddingRight: "m" }, /* @__PURE__ */ React.createElement(Toggle, { disabled, value: on, label: name, onChange: () => onGroupToggle() })), /* @__PURE__ */ React.createElement(Stack, { padding: "s", paddingLeft: "m", paddingRight: "m", gap: "xs" }, items.map((item) => /* @__PURE__ */ React.createElement(
  Toggle,
  {
    key: String(item.id),
    disabled,
    value: item.value,
    label: item.label,
    onChange: () => onItemToggle(item.id)
  }
))));
